import { getIcon } from "./IrisGridIcons.js";
class IrisGridCellRendererUtils {
  static drawTreeMarker(context, state, columnX, rowY, treeBox, color, isExpanded) {
    context.save();
    var theme = state.theme;
    var iconSize = theme.iconSize;
    var x1 = treeBox.x1,
      x2 = treeBox.x2,
      y1 = treeBox.y1,
      y2 = treeBox.y2;
    var markerIcon = isExpanded ? getIcon('caretDown', iconSize) : getIcon('caretRight', iconSize);
    var iconX = columnX + (x1 + x2) / 2 - iconSize / 2; // Midpoint of the tree box minus half the icon width
    var iconY = rowY + (y2 - y1 - iconSize) / 2; // y2 - y1 is effectively rowHeight

    context.fillStyle = color;
    context.textAlign = 'center';
    context.translate(iconX, iconY);
    context.fill(markerIcon);
    context.restore();
  }
}
export default IrisGridCellRendererUtils;
//# sourceMappingURL=IrisGridCellRendererUtils.js.map